import { render, staticRenderFns } from "./dxjqr.vue?vue&type=template&id=3217a585&scoped=true"
import script from "./dxjqr.vue?vue&type=script&lang=js"
export * from "./dxjqr.vue?vue&type=script&lang=js"
import style0 from "./dxjqr.vue?vue&type=style&index=0&id=3217a585&prod&lang=less"
import style1 from "./dxjqr.vue?vue&type=style&index=1&id=3217a585&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217a585",
  null
  
)

export default component.exports